import { Card } from '@amelio/ui-library';

import { DraftBanner } from './DraftBanner';
import { EmployeeCalibrationTable } from './EmployeeCalibrationTable';
import { CARD_SECTION } from '../calibrationStyles';
import { countDraftAdjustments, flattenEmployees } from '../utils/reportAdjustments';

import type { JobTitleLabels } from '../utils/jobTitleLabels';
import type { CalibrationReport } from '@/types/calibration';

export interface EmployeeViewCardProps {
    report: CalibrationReport;
    language: string;
    jobTitleLabels: JobTitleLabels;
    onBulkAdjust: () => void;
    onPublish: () => void;
}

/** The employee tile's card: where the cycle's calibrations stand, then the rows themselves. */
export const EmployeeViewCard = ({
    report,
    language,
    jobTitleLabels,
    onBulkAdjust,
    onPublish,
}: EmployeeViewCardProps) => (
    <Card
        glass={'sm'}
        borderRadius={'2xl'}
        shadow={'sm'}
        padding={'none'}
        dataTestId={'calibration-employee-card'}
    >
        <div className={CARD_SECTION}>
            <DraftBanner
                hasDraftAdjustments={countDraftAdjustments(report) > 0}
                hasAdjustableEmployees={flattenEmployees(report).length > 0}
                onBulkAdjust={onBulkAdjust}
                onPublish={onPublish}
            />

            <EmployeeCalibrationTable
                report={report}
                cycleEvaluationId={report.cycleEvaluationId}
                language={language}
                jobTitleLabels={jobTitleLabels}
            />
        </div>
    </Card>
);
